import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/Login'
import NotFount from '@/pages/404'
import Base from '@/pages/base/Base'
import PerReset from '@/pages/per_reset/PerReset'
import Companies from '@/pages/companies/Companies'
import CompaniesNew from '@/pages/companies/CompaniesNew'
import FinanceSwitch from '@/pages/companies/FinanceSwitch'
import CompanyFiles from '@/pages/companies/CompanyFiles'
import Authority from '@/pages/authority/Authority'
import User from '@/pages/authority/User'
import Index from '@/pages/index/Index'
import Problem from '@/pages/problem/Problem'
import Category from '@/pages/problem/Category'
import Demand from '@/pages/user/Demand'
import CcrmpDemand from '@/pages/user/CcrmpDemand'
import Options from '@/pages/options/Options'
import Poster from '@/pages/poster/Poster'
import PosterCategory from '@/pages/poster/PosterCategory'
import Logs from '@/pages/logs/Logs'
import FaceVerified from '@/pages/face_verified/FaceVerified'
import TycOrder from '@/pages/tyc_order/TycOrder'
import CloudComCount from '@/pages/tyc_order/CloudComCount'
import Speed from '@/pages/speed/Speed'
import TycOrderRefund from '@/pages/tyc_order_refund/TycOrderRefund'
import TycOrderStatus from '@/pages/tyc_order_status/TycOrderStatus'
import TycAnalysis from '@/pages/tyc_analysis/TycAnalysis'
import UserGroup from '@/pages/conversation/UserGroup'
import Clientele from '@/pages/conversation/Clientele'
import Chats from '@/pages/conversation/Chats'
import ChatMessages from '@/pages/conversation/ChatMessages'
import ReplyTimeOut from '@/pages/conversation/ReplyTimeOut'
import QyWxRecord from '@/pages/qykj/QyWxRecord'
import QyChatMessages from '@/pages/qykj/QyChatMessages'
import Quality from '@/pages/conversation/Quality'
import TycCluePool from '@/pages/tyc_clue_pool/TycCluePool'
import FIPTC from '@/pages/tyc_clue_pool/FallIntoPublicThreadConfig'
import Clues from '@/pages/clues/clues'
import CluesAnalyse from '@/pages/clues_analyse/clues_analyse'
import CluesManage from '@/pages/clues_manage/clues_manage'
import OtherClues from '@/pages/other_clues/other_clues'
import Ranking from '@/pages/ranking/ranking'
import PfmRanking from '@/pages/pfm_ranking/pfm_ranking'
import SalesTalkManage from '@/pages/Sales_Talk_Manage/Sales_Talk_Manage'
import SalesTalkLabelManage from '@/pages/SalesTalkLabelManage/SalesTalkLabelManage'
import SalesTalkTypeManage from '@/pages/SalesTalkTypeManage/SalesTalkTypeManage'
import CluesAllot from '@/pages/clues_allot/clues_allot'
import TypeManage from '@/pages/type_manage/type_manage'
import ServiceManage from '@/pages/service_manage/service_manage'
import FlagManage from '@/pages/flag_manage/flag_manage'
import FlagChart from '@/pages/flag_manage/flag_chart/flag_chart'
import CluesTease from '@/pages/clues_tease/clues_tease'
import StudyArticleManage from '@/pages/studyPlatfrom/study_article_manage'
import StudyTypeManage from '@/pages/studyPlatfrom/study_type_manage'
import CommunicatStat from '@/pages/communicat_stat/communicat_stat'
// import FinanceRegister from '@/pages/finance_register/FinanceRegister'
import FlagPlan from '@/pages/flag_plan/flag_plan'
import RecordDetail from '@/pages/record_detail/record_detail'
import Place from '@/pages/record_place/Place'
import Invoicing from '@/pages/invoicing/Invoicing'
import InvoiceInfo from '@/pages/invoicing/Invoice_info'
import Bill from '@/pages/invoicing/Bill'
import RecordApplicat from '@/pages/record_applicat/RecordApplicat'
import RecordConnect from '@/pages/record_connect/record_connect'
import BussinessChange from '@/pages/bussiness_change/BussinessChange'
import MyBussiness from '@/pages/my_bussiness/MyBussiness'
import BussinessManage from '@/pages/bussiness_manage/BussinessManage'
import BussinessSuggest from '@/pages/bussiness_suggest/BussinessSuggest'
import BussinessStat from '@/pages/bussiness_stat/bussiness_stat'
import BussinessTotal from '@/pages/bussiness_total/bussiness_total'
import InternalClass from '@/pages/internal_class/internal_class'
import CallCount from '@/pages/call_count/CallCount'
import CallDetailVail from '@/pages/call_detail_vail/CallDetailVail'
import CallDetailVailBj from '@/pages/call_detail_vail/CallDetailVailBj'
import FinanceInfo from '@/pages/finance_info/FinanceInfo'
import FinanceAnalyse from '@/pages/finance_analyse/FinanceAnalyse'
import Order from '@/pages/customer/Order'
import Schedule from '@/pages/customer/Schedule'
import RegInfoTable from '@/pages/customer/RegInfoTable'
import RegInfoCreate from '@/pages/customer/RegInfoCreate'
import RegmationCount from '@/pages/customer/RegmationCount'
import Change from '@/pages/customer/Change'
import Logout from '@/pages/customer/Logout'
import BankOpen from '@/pages/customer/BankOpen'
import TaxReg from '@/pages/customer/TaxReg'
import FinanceTable from '@/pages/finance_register/FinanceTable'
import FinanceTaxation from '@/pages/financeTaxation/FinanceTaxation'
import HandOut from '@/pages/financeTaxation/HandOut'
import MaterialRegistration from '@/pages/finance_register/MaterialRegistration'
import StaffInfo from '@/pages/staff_info/StaffInfo'
import Voucher from '@/pages/voucher/Voucher'
import Annals from '@/pages/annals/Annals'
import AppointmentCancel from '@/pages/appointment_cancel/AppointmentCancel'
import Declaration from '@/pages/declaration/Declaration'
import Customers from '@/pages/my_customers/Customers'
import NewCustomers from '@/pages/my_customers/NewCustomers'
import ExpManage from '@/pages/exp_manage/ExpManage'
import ExpManageCate from '@/pages/exp_manage/ExpManageCate'
import Print from '@/pages/exp_manage/print'
import Any from '@/pages/any/Any'
import Accumulation from '@/pages/any_accumulation/Accumulation'
import FeiShu from '@/pages/feishu/FeiShu'
import Documentation from '@/pages/feishu/Documentation'
import Cfcategory from '@/pages/cloud_file/CFcategory'
import Cfbody from '@/pages/cloud_file/CFbody'
import Handover from '@/pages/handover/Handover'
import HandoverRec from '@/pages/handover/HandoverRec'
import AdviceCate from '@/pages/advice/AdviceCate'
import Advice from '@/pages/advice/Advice'
import WxworkFileMessages from '@/pages/conversation/WxworkFileMessages'
import QualityInspection from '@/pages/quality_inspection/QualityInspection'
import QualityInspectionCate from '@/pages/quality_inspection/QualityInspectionCate'
import Contract from '@/pages/contract/Contract'
import ContractTemplate from '@/pages/contract/ContractTemplate'
import ScheduleCate from '@/pages/schedule/ScheduleCate'
import ScheduleBody from '@/pages/schedule/Schedule'
import ScheduleAddress from '@/pages/schedule/ScheduleAddress'
import ServiceIn from '@/pages/schedule/ServiceIn'
import ServiceInCopy from '@/pages/schedule/ServiceInCopy'
import MySchedule from '@/pages/schedule/MySchedule'
import TycProducts from '@/pages/tyc_products/TycProducts'
import WeAppPayOrders from '@/pages/we_app_pay_orders/WeAppPayOrders'
import MoneyInCategory from '@/pages/setting_panel/MoneyInCategory'
import CheckSetting from '@/pages/setting_panel/CheckSetting'
import ProcessCheck from '@/pages/setting_panel/ProcessCheck'
import ProcessCheckGoal from '@/pages/setting_panel/ProcessCheckGoal'
import ClientManage from '@/pages/client_manage/ClientManage'
import ClientAccess from '@/pages/client_access/ClientAccess'
import ClientLevel from '@/pages/client_level/ClientLevel'
import ProductAddition from '@/pages/product_addition/product_addition'
import ProductTypegory from '@/pages/service_manage/ProductTypegory'
import combProductType from '@/pages/service_manage/combProductType'
import WorkDiary from '@/pages/work_diary/WorkDiary'
import JianZhou from '@/pages/jianzhou/jianzhou'
import SmsCate from '@/pages/jianzhou/smsCate'
import SearchRecords from '@/pages/my_customers/search_records'
import AccessRecords from '@/pages/my_customers/access_records'
import SearchAccess from '@/pages/my_customers/search_access'
import WxWorkChatInspectionCate from '@/pages/wx_work_chat_inspection/WxWorkChatInspectionCate'
import WxWorkChatInspectionContent from '@/pages/wx_work_chat_inspection/WxWorkChatInspectionContent'
import WxWorkChatInspection from '@/pages/wx_work_chat_inspection/WxWorkChatInspection'
import VipOrders from '@/pages/vip_orders/vip_orders'
import TycCluePoolTM from '@/pages/tyc_clue_pool/TycCluePoolTM'
import MsgManage from '@/pages/msg_manage/MsgManage'
import MsgCate from '@/pages/msg_manage/MsgCate'
import MenuManage from '@/pages/menus_manage/MenuManage'
import OfficialNav from '@/pages/official_nav/nav_body'
import KnowledgeHierarchy from '@/pages/knowledge/knowledge_hierarchy'
import KnowledgeProcess from '@/pages/knowledge/knowledge_process'
import OfficialBottom from '@/pages/official_bottom/bottom_body'
import SettingPanel from '@/pages/setting_panel/SettingPanel'
import ServiceNameList from '@/pages/setting_panel/ServiceNameList'
import TctypeList from '@/pages/setting_panel/TctypeList'
import DptypeList from '@/pages/setting_panel/DptypeList'
import OrderTypeList from '@/pages/setting_panel/OrderTypeList'
import SjzcTypeList from '@/pages/setting_panel/SjzcTypeList'
import HyManageList from '@/pages/setting_panel/HyManageList'
import TkreasonList from '@/pages/setting_panel/TkreasonList'
import KhfromList from '@/pages/setting_panel/KhfromList'
import NoneedList from '@/pages/setting_panel/NoneedList'
import SsareaList from '@/pages/setting_panel/SsareaList'
import GsscaleList from '@/pages/setting_panel/GsscaleList'
import HdtaxCateList from '@/pages/setting_panel/HdtaxCateList'
import SjcontentList from '@/pages/setting_panel/SjcontentList'
import SsTaxOfficeList from '@/pages/setting_panel/SsTaxOfficeList'
import SsMarketList from '@/pages/setting_panel/SsMarketList'
import TsreasonList from '@/pages/setting_panel/TsreasonList'
import OrderPlatformList from '@/pages/setting_panel/OrderPlatformList'
import CompanyAreaList from '@/pages/setting_panel/CompanyAreaList'
import CompanyParkList from '@/pages/setting_panel/CompanyParkList'
import DischargeRecord from '@/pages/discharge_record/DischargeRecord'
import PolicyList from '@/pages/policy/PolicyList'
import MemberCard from '@/pages/member_card/MemberCard'
import ApplicationPolicy from '@/pages/company_policy/ApplicationPolicy'
import HandoverExamine from '@/pages/handover/HandoverExamine'
import OrderRegister from '@/pages/order_register/OrderRegister'
import StaffMsgs from '@/pages/staff_info/StaffMsgs'
import TradeBillRecord from '@/pages/tradebill_record/TradeBillRecord'
import InvoiceRecord from '@/pages/invoice_record/InvoiceRecord'
import FlyingBook from '@/pages/flying_book/FlyingBook'
import AlipayTradeBill from '@/pages/alipay_tradebill/AlipayTradeBill'
import PddCallback from '@/pages/pdd_auth_callback/PddCallback'
import ShopList from '@/pages/shop_list/ShopList'
import TycModel from '@/pages/tyc_order/TycModel'
import RecruitManage from '@/pages/personnelManagement/RecruitManage'
import ComplaintManage from '@/pages/complaint_manage/ComplaintManage'
import UpFile from '@/common/UpFile'
import CcrmpAliOrder from '@/pages/ccrmp_orders/CcrmpAliOrder'
import CcrmpWcOrder from '@/pages/ccrmp_orders/CcrmpWcOrder'
import CcrmpCS from '@/pages/ccrmp_complaint_suggestions/CcrmpCS'
import CompanySet from '@/pages/company_set/CompanySet'
import SingleItem from '@/pages/setting_panel/SingleItem'
import OrderAreaAnalysis from '@/pages/order_area_analysis/OrderAreaAnalysis'
import YsyTest from '@/pages/ysy/testCom'
import YsyTestFeiShuButton from '@/pages/ysy/FeishuButton'
import YsyTestFeiShuDoc from '@/pages/ysy/FeishuDoc'
import YsyTestWorkWeiXinAuth from '@/pages/ysy/WorkWeiXinAuth'
import YsyTestWorkWeiXinAuthShow from '@/pages/ysy/WorkWeiXinAuthShow'
import YsyTestMpQQUploadTemp from '@/pages/ysy/mpQQUpLoadTemp'
import QYHConfig from '@/pages/miniProQiYeHuoConfig/QiYeHuo'
import QYHHeadBg from '@/pages/miniProQiYeHuoConfig/HeadBg'
import CCRMPIndex from '@/pages/miniProCCRMPConfig/Index'
import CCRMPCityPark from '@/pages/miniProCCRMPConfig/CityPark'
import PalmConfigurationPage from '@/pages/miniProZhangShangBanConfig/PalmConfigurationPage'
import PalmContract from '@/pages/miniProZhangShangBanConfig/PalmContract'
import CustomerBelongs from '@/pages/setting_panel/CustomerBelongs'
import CommonArticleCate from '@/pages/studyPlatfrom/study_type_manage_common'
import CommonArticle from '@/pages/studyPlatfrom/study_article_manage_common'
import CcrmpQyhOrder from '@/pages/ccrmp_orders/CcrmpQyhOrder'
import CcrmpAliAgentOrder from '@/pages/ccrmp_orders/CcrmpAliQyhAgentOrder'
import CcrmpBdOrder from '@/pages/ccrmp_orders/CcrmpBdOrder'
import CcrmpBaiduOrder from '@/pages/ccrmp_orders/CcrmpBaiduOrder'
import CcrmpRegNowOrder from '@/pages/ccrmp_orders/CcrmpRegNowOrder'
import ZllMarket from '@/pages/clues/ZllMarket'
import OrderFeedback from '@/pages/tyc_order/OrderFeedback'
import MarketPosterCategory from '@/pages/market_poster/PosterCategory'
import MarketPoster from '@/pages/market_poster/Poster'
import ThreadFeedback from '@/pages/clues_manage/ThreadFeedback'
import RenewCount from '@/pages/count/RenewCount'
import RoleInfo from '@/pages/count/RoleInfo'
import ToDoListCount from '@/pages/count/ToDoList'
import ValueAddedServices from '@/pages/setting_panel/Value-addedServices/Value-addedServices'
import DataAnalysis from '@/pages/data_analysis/DataAnalysis'
import ProcessAnalysis from '@/pages/data_analysis/ProcessAnalysis'
import PersonGoal from '@/pages/data_analysis/PersonGoal'
import ChatProcess from '@/pages/data_analysis/ChatProcess'
import ProcessTarget from '@/pages/data_analysis/ProcessTarget'
import ServiceProvider from '@/pages/setting_panel/ServiceProvider'
import PlacePark from '@/pages/setting_panel/PlacePark'
import UserSource from '@/pages/my_customers/UserSource'
import PromotionStatistics from '@/pages/PromotionStatistics/Index'
import UnPayOrder from '@/pages/UnPayOrder/Index'
import MiniProgramPic from '@/pages/setting_panel/MiniProgramPic'
import LicenceManage from '@/pages/setting_panel/LicenceManage'
import QyhPublicMenu from '@/pages/wxPublicConfig/QyhPublicMenu'
import WxPublicAutoMessage from '@/pages/wxPublicConfig/WxPublicAutoMessage'
import Business from '@/pages/dataization/Business'
import FinancerSwitch from '@/pages/setting_panel/FinancerSwitch'
import SoftAuthor from '@/pages/setting_panel/SoftAuthor'
import AlipayPromoteParamManage from '@/pages/setting_panel/AlipayPromoteParamManage'
import DataInventory from '@/pages/tyc_order/DataInventory'
import GsOverview from '@/pages/data_overview/GsOverview'
import CouponCodes from '@/pages/coupon_codes/CouponCodes'
import ZhbConsult from '@/pages/zhb_consult/ZhbConsult'
import TaskLists from '@/pages/task_lists/TaskLists'
import PublicIndex from '@/pages/PromotionStatistics/Public/PublicIndex'
import ChannelEffect from '@/pages/PromotionStatistics/ChannelEffect/ChannelEffect'
import TicketManage from '@/pages/ticket_manage/TicketManage'
import AdminUser from '@/pages/admin_user/AdminUser'
import ClassifyCollection from '@/pages/setting_panel/ClassifyCollection'
import OrderParentFrom from '@/pages/setting_panel/OrderParentFrom'
import CustomerParentSource from '@/pages/setting_panel/CustomerParentSource'
import CallTask from '@/pages/cloudClue/CallTask'
import CallTaskResource from '@/pages/cloudClue/CallTaskResource'
import CallTaskCount from '@/pages/cloudClue/CallTaskCount'
import CallTaskManage from '@/pages/cloudClue/CallTaskManage'
import CallTaskManageSecond from '@/pages/cloudClue/CallTaskManageSecond'
import EnterpriseQualification from '@/pages/CallTaskResource/EnterpriseQualification'
import HighIntentCustomer from '@/pages/cloudClue/HighIntentCustomer'
import Tool from '@/pages/Tool'
import CateManage from '@/pages/cloudClue/CateManage'
import CompanyServer from '@/pages/setting_panel/CompanyServer'
import AllProductView from '@/pages/all_products/AllProductView'
import ProductShowView from '@/pages/all_products/common/ProductShowView'
import UploadTasks from '@/pages/upload_tasks/UploadTasks'
import CompanyRisks from '@/pages/company_risks/CompanyRisks'
import IntellectualProperty from '@/pages/intellectual_property/IntellectualProperty'
import ExportTasks from '@/pages/export_tasks/ExportTasks'
import SelfExport from '@/pages/SelfExport/SelfExport'
import OrderView from '@/pages/data_overview/OrderView'
import OrderCountView from '@/pages/data_overview/OrderCountView'
import InvoiceDetail from '../pages/tyc_order/InvoiceDetail.vue'
import System from '@/System/OneButton.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      name: '404',
      component: NotFount
    },
    {
      path: '/',
      component: Base,
      children: [
        { path: '', component: Index },
        { path: 'per_reset', name: 'perReset', component: PerReset },
        { path: 'companies', name: 'Companies', component: Companies },
        { path: 'company_new', name: 'CompaniesNew', component: CompaniesNew },
        { path: 'finance_switch', name: 'FinanceSwitch', component: FinanceSwitch },
        { path: 'company_files', name: 'CompanyFiles', component: CompanyFiles },
        { path: 'authority', name: 'authority', component: Authority },
        { path: 'user', name: 'user', component: User },
        { path: 'problem', name: 'Problem', component: Problem },
        { path: 'category', name: 'Category', component: Category },
        { path: 'demand', name: 'Demand', component: Demand },
        { path: 'ccrmp_demand', name: 'CcrmpDemand', component: CcrmpDemand },
        { path: 'options', name: 'Options', component: Options },
        { path: 'poster', name: 'Poster', component: Poster },
        { path: 'posterCategory', name: 'PosterCategory', component: PosterCategory },
        { path: 'logs', name: 'Logs', component: Logs },
        { path: 'face_verified', name: 'FaceVerified', component: FaceVerified },
        { path: 'tyc_order', name: 'TycOrder', component: TycOrder },
        { path: 'cloud_com_count', name: 'CloudComCount', component: CloudComCount },
        { path: 'speed', name: 'Speed', component: Speed },
        { path: 'tyc_order_refund', name: 'TycOrderRefund', component: TycOrderRefund },
        { path: 'tyc_order_status', name: 'TycOrderStatus', component: TycOrderStatus },
        { path: 'tyc_analysis', name: 'TycAnalysis', component: TycAnalysis },
        { path: 'user_group', name: 'UserGroup', component: UserGroup },
        { path: 'clientele', name: 'Clientele', component: Clientele },
        { path: 'tyc_clue_pool', name: 'TycCluePool', component: TycCluePool },
        { path: 'fiptc', name: 'FIPTC', component: FIPTC },
        { path: 'clues', name: 'Clues', component: Clues },
        { path: 'clues_analyse', name: 'CluesAnalyse', component: CluesAnalyse },
        { path: 'clues_manage', name: 'CluesManage', component: CluesManage },
        { path: 'other_clues', name: 'OtherClues', component: OtherClues },
        { path: 'ranking', name: 'Ranking', component: Ranking },
        { path: 'pfm_ranking', name: 'PfmRanking', component: PfmRanking },
        { path: 'Sales_Talk_Manage', name: 'SalesTalkManage', component: SalesTalkManage },
        { path: 'SalesTalkLabelManage', name: 'SalesTalkLabelManage', component: SalesTalkLabelManage },
        { path: 'SalesTalkTypeManage', name: 'SalesTalkTypeManage', component: SalesTalkTypeManage },
        { path: 'clues_allot', name: 'CluesAllot', component: CluesAllot },
        { path: 'type_manage', name: 'type_manage', component: TypeManage },
        { path: 'service_manage', name: 'service_manage', component: ServiceManage },
        { path: 'flag_manage', name: 'flag_manage', component: FlagManage },
        { path: 'flag_chart', name: 'flag_chart', component: FlagChart },
        { path: 'clues_tease', name: 'clues_tease', component: CluesTease },
        { path: 'study_article_manage', name: 'study_article_manage', component: StudyArticleManage },
        { path: 'study_type_manage', name: 'study_type_manage', component: StudyTypeManage },
        { path: 'communicat_stat', name: 'communicat_stat', component: CommunicatStat },
        { path: 'flag_plan', name: 'flag_plan', component: FlagPlan },
        { path: 'record_detail', name: 'record_detail', component: RecordDetail },
        { path: 'place', name: 'place', component: Place },
        { path: 'record_applicat', name: 'RecordApplicat', component: RecordApplicat },
        { path: 'record_connect', name: 'record_connect', component: RecordConnect },
        { path: 'chat_process', name: 'ChatProcess', component: ChatProcess },
        { path: 'BussinessChange', name: 'BussinessChange', component: BussinessChange },
        { path: 'MyBussiness', name: 'MyBussiness', component: MyBussiness },
        { path: 'BussinessManage', name: 'BussinessManage', component: BussinessManage },
        { path: 'BussinessSuggest', name: 'BussinessSuggest', component: BussinessSuggest },
        { path: 'bussiness_stat', name: 'bussiness_stat', component: BussinessStat },
        { path: 'bussiness_total', name: 'bussiness_total', component: BussinessTotal },
        { path: 'internal_class', name: 'internal_class', component: InternalClass },
        { path: 'invoicing', name: 'Invoicing', component: Invoicing },
        { path: 'invoice_info', name: 'InvoiceInfo', component: InvoiceInfo },
        { path: 'bill', name: 'Bill', component: Bill },
        { path: 'callCount', name: 'CallCount', component: CallCount },
        { path: 'call_detail_vail', name: 'CallDetailVail', component: CallDetailVail },
        { path: 'call_detail_vail_bj', name: 'CallDetailVailBj', component: CallDetailVailBj },
        { path: 'finance_info', name: 'finance_info', component: FinanceInfo },
        { path: 'finance_analyse', name: 'finance_analyse', component: FinanceAnalyse },
        { path: 'chats', name: 'chats', component: Chats },
        { path: 'chat_messages', name: 'chat_messages', component: ChatMessages },
        { path: 'reply_time_out', name: 'ReplyTimeOut', component: ReplyTimeOut },
        { path: 'qy_wx_record', name: 'qy_wx_record', component: QyWxRecord },
        { path: 'qy_chat_messages', name: 'qy_chat_messages', component: QyChatMessages },
        { path: 'quality', name: 'quality', component: Quality },
        { path: 'order', name: 'order', component: Order },
        { path: 'schedule', name: 'schedule', component: Schedule },
        { path: 'reg_info_table', name: 'RegInfoTable', component: RegInfoTable },
        { path: 'regmation_count', name: 'RegmationCount', component: RegmationCount },
        { path: 'change', name: 'change', component: Change },
        { path: 'logout', name: 'logout', component: Logout },
        { path: 'bank_open', name: 'bank_open', component: BankOpen },
        { path: 'tax_reg', name: 'tax_reg', component: TaxReg },
        { path: 'finance_table', name: 'finance_table', component: FinanceTable },
        { path: 'finance_taxation', name: 'finance_taxation', component: FinanceTaxation },
        { path: 'ft_hand_out', name: 'HandOut', component: HandOut },
        { path: 'material_registration', name: 'material_registration', component: MaterialRegistration },
        { path: 'staff_info', name: 'staff_info', component: StaffInfo },
        { path: 'annals', name: 'annals', component: Annals },
        { path: 'voucher', name: 'voucher', component: Voucher },
        { path: 'appointment_cancel', name: 'AppointmentCancel', component: AppointmentCancel },
        { path: 'declaration_remind', name: 'Declaration', component: Declaration },
        { path: 'my_customers', name: 'Customers', component: Customers },
        { path: 'new_my_customers', name: 'newCustomers', component: NewCustomers },
        { path: 'exp_manage', name: 'ExpManage', component: ExpManage },
        { path: 'exp_manage_cate', name: 'ExpManageCate', component: ExpManageCate },
        { path: 'any', name: 'Any', component: Any },
        { path: 'any_accumulation', name: 'Accumulation', component: Accumulation },
        { path: 'cf_category', name: 'Cfcategory', component: Cfcategory },
        { path: 'cf_list', name: 'Cfbody', component: Cfbody },
        { path: 'handover', name: 'Handover', component: Handover },
        { path: 'handover_rec', name: 'HandoverRec', component: HandoverRec },
        { path: 'advice_cate', name: 'AdviceCate', component: AdviceCate },
        { path: 'advice', name: 'Advice', component: Advice },
        { path: 'wxwork_file_messages', name: 'WxworkFileMessages', component: WxworkFileMessages },
        { path: 'quality_inspection', name: 'QualityInspection', component: QualityInspection },
        { path: 'quains_cate', name: 'QualityInspectionCate', component: QualityInspectionCate },
        { path: 'contract', name: 'contract', component: Contract },
        { path: 'contract_template', name: 'contract_template', component: ContractTemplate },
        { path: 'schedule_cate', name: 'ScheduleCate', component: ScheduleCate },
        { path: 'schedule_body', name: 'Schedule', component: ScheduleBody },
        { path: 'service_in', name: 'ServiceIn', component: ServiceIn },
        { path: 'service_in_c', name: 'ServiceInCopy', component: ServiceInCopy },
        { path: 'schedule_address', name: 'ScheduleAddress', component: ScheduleAddress },
        { path: 'myschedule', name: 'MySchedule', component: MySchedule },
        { path: 'tyc_products', name: 'tycProducts', component: TycProducts },
        { path: 'we_app_pay_orders', name: 'weAppPayOrders', component: WeAppPayOrders },
        { path: 'moneyin_cate', name: 'MoneyInCategory', component: MoneyInCategory },
        { path: 'check_setting', name: 'CheckSetting', component: CheckSetting },
        { path: 'process_check', name: 'ProcessCheck', component: ProcessCheck },
        { path: 'process_check_goal', name: 'ProcessCheckGoal', component: ProcessCheckGoal },
        { path: 'client_manage', name: 'client_manage', component: ClientManage },
        { path: 'client_access', name: 'client_access', component: ClientAccess },
        { path: 'client_level', name: 'client_level', component: ClientLevel },
        { path: 'product_addition', name: 'product_addition', component: ProductAddition },
        { path: 'product_type', name: 'ProductTypegory', component: ProductTypegory },
        { path: 'comb_product_type', name: 'combProductType', component: combProductType },
        { path: 'work_diary', name: 'WorkDiary', component: WorkDiary },
        { path: 'jianzhou', name: 'JianZhou', component: JianZhou },
        { path: 'jianzhou_cate', name: 'SmsCate', component: SmsCate },
        { path: 'search_records', name: 'SearchRecords', component: SearchRecords },
        { path: 'access_records', name: 'AccessRecords', component: AccessRecords },
        { path: 'search_access', name: 'SearchAccess', component: SearchAccess },
        { path: 'wx_in_cate', name: 'WxWorkChatInspectionCate', component: WxWorkChatInspectionCate },
        { path: 'wx_in_content', name: 'WxWorkChatInspectionContent', component: WxWorkChatInspectionContent },
        { path: 'wx_in', name: 'WxWorkChatInspection', component: WxWorkChatInspection },
        { path: 'vip_orders', name: 'VipOrders', component: VipOrders },
        { path: 'tyc_clue_pool_tm', name: 'TycCluePoolTM', component: TycCluePoolTM },
        { path: 'msg_manage', name: 'MsgManage', component: MsgManage },
        { path: 'msg_cate', name: 'MsgCate', component: MsgCate },
        { path: 'menus_manage', name: 'MenuManage', component: MenuManage },
        { path: 'nav_body', name: 'OfficialNav', component: OfficialNav },
        { path: 'knowledge_hierarchy', name: 'KnowledgeHierarchy', component: KnowledgeHierarchy },
        { path: 'knowledge_process', name: 'KnowledgeProcess', component: KnowledgeProcess },
        { path: 'bottom_body', name: 'OfficialBottom', component: OfficialBottom },
        { path: 'setting_panel', name: 'SettingPanel', component: SettingPanel },
        { path: 'service_provider', name: 'ServiceProvider', component: ServiceProvider },
        { path: 'service_list', name: 'ServiceNameList', component: ServiceNameList },
        { path: 'tctype_list', name: 'TctypeList', component: TctypeList },
        { path: 'dptype_list', name: 'DptypeList', component: DptypeList },
        { path: 'ddtype_list', name: 'OrderTypeList', component: OrderTypeList },
        { path: 'sjzctype_list', name: 'SjzcTypeList', component: SjzcTypeList },
        { path: 'hygltype_list', name: 'HyManageList', component: HyManageList },
        { path: 'tkreason_list', name: 'TkreasonList', component: TkreasonList },
        { path: 'khfrom_list', name: 'KhfromList', component: KhfromList },
        { path: 'noneed_list', name: 'NoneedList', component: NoneedList },
        { path: 'ssarea_list', name: 'SsareaList', component: SsareaList },
        { path: 'gsscale_list', name: 'GsscaleList', component: GsscaleList },
        { path: 'hdtax_list', name: 'HdtaxCateList', component: HdtaxCateList },
        { path: 'sjcontent_list', name: 'SjcontentList', component: SjcontentList },
        { path: 'sstax_list', name: 'SsTaxOfficeList', component: SsTaxOfficeList },
        { path: 'ssmarket_list', name: 'SsMarketList', component: SsMarketList },
        { path: 'tsreason_list', name: 'TsreasonList', component: TsreasonList },
        { path: 'order_platform', name: 'OrderPlatformList', component: OrderPlatformList },
        { path: 'company_area', name: 'CompanyAreaList', component: CompanyAreaList },
        { path: 'company_park', name: 'CompanyParkList', component: CompanyParkList },
        { path: 'discharge_record', name: 'DischargeRecord', component: DischargeRecord },
        { path: 'policy_list', name: 'PolicyList', component: PolicyList },
        { path: 'member_card', name: 'MemberCard', component: MemberCard },
        { path: 'application_policy', name: 'ApplicationPolicy', component: ApplicationPolicy },
        { path: 'handover_examine', name: 'HandoverExamine', component: HandoverExamine },
        { path: 'order_register', name: 'OrderRegister', component: OrderRegister },
        { path: 'staff_msgs', name: 'staff_msgs', component: StaffMsgs },
        { path: 'tradebill', name: 'TradeBillRecord', component: TradeBillRecord },
        { path: 'invoice_record', name: 'InvoiceRecord', component: InvoiceRecord },
        { path: 'flying_book', name: 'FlyingBook', component: FlyingBook },
        { path: 'alipay_tradebill', name: 'AlipayTradeBill', component: AlipayTradeBill },
        { path: 'shop_list', name: 'ShopList', component: ShopList },
        { path: 'tyc_model', name: 'TycModel', component: TycModel },
        { path: 'recruit_manage', name: 'RecruitManage', component: RecruitManage },
        { path: 'up_file', name: 'UpFile', component: UpFile },
        { path: 'complaint_manage', name: 'ComplaintManage', component: ComplaintManage },
        { path: 'ccrmp_ali_order', name: 'CcrmpAliOrder', component: CcrmpAliOrder },
        { path: 'ccrmp_wc_order', name: 'CcrmpWcOrder', component: CcrmpWcOrder },
        { path: 'ccrmp_baidu_order', name: 'CcrmpBaiduOrder', component: CcrmpBaiduOrder },
        { path: 'ccrmp_rn_order', name: 'CcrmpRegNowOrder', component: CcrmpRegNowOrder },
        { path: 'ccrmp_qyh_order', component: CcrmpQyhOrder },
        { path: 'ccrmp_ali_agent_order', component: CcrmpAliAgentOrder },
        { path: 'ccrmp_bd_order', component: CcrmpBdOrder },
        { path: 'ccrmp_cs', name: 'CcrmpCS', component: CcrmpCS },
        { path: 'company_set', name: 'CompanySet', component: CompanySet },
        { path: 'dl_si_manage', component: SingleItem },
        { path: 'order_area_analysis', name: 'OrderAreaAnalysis', component: OrderAreaAnalysis },
        { path: 'ysy_test', component: YsyTest },
        { path: 'feishu_button', component: YsyTestFeiShuButton },
        { path: 'feishu_doc', component: YsyTestFeiShuDoc },
        { path: 'work_weixin_auth', component: YsyTestWorkWeiXinAuth },
        { path: 'mpqq_ut', component: YsyTestMpQQUploadTemp },
        { path: 'qyh_config', component: QYHConfig },
        { path: 'qyh_head_bg', component: QYHHeadBg },
        { path: 'ccrmp_config', component: CCRMPIndex },
        { path: 'ccrmp_city_park', component: CCRMPCityPark },
        { path: 'palm_configuration_page', component: PalmConfigurationPage },
        { path: 'palm_contract', component: PalmContract },
        { path: 'customer_belongs', name: 'CustomerBelongs', component: CustomerBelongs },
        { path: 'common_ac', component: CommonArticleCate },
        { path: 'common_a', component: CommonArticle },
        { path: 'zll_market', component: ZllMarket },
        { path: 'm_poster_c', component: MarketPosterCategory },
        { path: 'm_poster', component: MarketPoster },
        { path: 'renew_count', component: RenewCount },
        { path: 'todolist_count', component: ToDoListCount },
        { path: 'role_info', component: RoleInfo },
        { path: 'value_added', component: ValueAddedServices },
        { path: 'order_feedback', name: 'OrderFeedback', component: OrderFeedback },
        { path: 'thread_feedback', name: 'ThreadFeedback', component: ThreadFeedback },
        { path: 'data_analysis', name: 'DataAnalysis', component: DataAnalysis },
        { path: 'process_analysis', name: 'ProcessAnalysis', component: ProcessAnalysis },
        { path: 'person_goal', name: 'PersonGoal', component: PersonGoal },
        { path: 'process_target', name: 'ProcessTarget', component: ProcessTarget },
        { path: 'place_park', name: 'PlacePark', component: PlacePark },
        { path: 'user_source', name: 'UserSource', component: UserSource },
        { path: 'ps_index', name: 'PromotionStatistics', component: PromotionStatistics },
        { path: 'ps_public', name: 'PublicIndex', component: PublicIndex },
        { path: 'ps_ce', name: 'ChannelEffect', component: ChannelEffect },
        { path: 'u_p_order', name: 'UnPayOrder', component: UnPayOrder },
        { path: 'mini_program_pic', name: 'MiniProgramPic', component: MiniProgramPic },
        { path: 'licence_manage', name: 'LicenceManage', component: LicenceManage },
        { path: 'wx_public_menu', name: 'QyhPublicMenu', component: QyhPublicMenu },
        { path: 'wx_public_auto_message', name: 'WxPublicAutoMessage', component: WxPublicAutoMessage },
        { path: 'financer_switch', name: 'FinancerSwitch', component: FinancerSwitch },
        { path: 'soft_author', name: 'SoftAuthor', component: SoftAuthor },
        { path: 'alipay_promote_params_manage', name: 'AlipayPromoteParamManage', component: AlipayPromoteParamManage },
        { path: 'data_inventory', name: 'DataInventory', component: DataInventory },
        { path: 'gs_overview', name: 'GsOverview', component: GsOverview },
        { path: 'coupon_codes', name: 'CouponCodes', component: CouponCodes },
        { path: 'zhb_consult', name: 'ZhbConsult', component: ZhbConsult },
        { path: 'task_lists', name: 'TaskLists', component: TaskLists },
        { path: 'ticket_manage', name: 'TicketManage', component: TicketManage },
        { path: 'admin_user', name: 'AdminUser', component: AdminUser },
        { path: 'classify_collection', name: 'ClassifyCollection', component: ClassifyCollection },
        { path: 'order_parent_from', name: 'OrderParentFrom', component: OrderParentFrom },
        { path: 'customer_parent_source', name: 'CustomerParentSource', component: CustomerParentSource },
        { path: 'call_task/:cate/:keyword/:tword/:other', name: 'CallTask', component: CallTask },
        { path: 'call_task_resource', name: 'CallTaskResource', component: CallTaskResource },
        { path: 'call_task_c', name: 'CallTaskCount', component: CallTaskCount },
        { path: 'call_task_m', name: 'CallTaskManage', component: CallTaskManage },
        { path: 'call_task_m_s/:id', name: 'CallTaskManageSecond', component: CallTaskManageSecond },
        { path: 'ct_cate_manage', name: 'CateManage', component: CateManage },
        { path: 'call_task_resource_qualifications', name: 'EnterpriseQualification', component: EnterpriseQualification },
        { path: 'high_intent_customer', name: 'HighIntentCustomer', component: HighIntentCustomer },
        { path: 'tool', name: 'Tool', component: Tool },
        { path: 'company_server', name: 'CompanyServer', component: CompanyServer },
        { path: 'all_products', name: 'AllProductView', component: AllProductView },
        { path: 'upload_tasks', name: 'UploadTasks', component: UploadTasks },
        { path: 'company_risks', name: 'CompanyRisks', component: CompanyRisks },
        { path: 'intellectual_property', name: 'IntellectualProperty', component: IntellectualProperty },
        { path: 'export_tasks', name: 'ExportTasks', component: ExportTasks },
        { path: 'self_export', name: 'SelfExport', component: SelfExport },
        { path: 'order_view', name: 'OrderView', component: OrderView },
        { path: 'order_count_view', name: 'OrderCountView', component: OrderCountView },
        { path: 'invoice_detail', name: 'InvoiceDetail', component: InvoiceDetail },
      ]
    },
    { path: '/work_weixin_auth_show', component: YsyTestWorkWeiXinAuthShow },
    { path: '/reg_info_create', name: 'RegInfoCreate', component: RegInfoCreate },
    { path: '/feishu', name: 'FeiShu', component: FeiShu },
    { path: '/documentation', name: 'documentation', component: Documentation },
    { path: '/login', name: 'Login', component: Login },
    { path: '/exp_print', name: 'Print', component: Print },
    { path: '/pdd_auth_callback', name: 'PddCallback', component: PddCallback },
    { path: '/dataization_business', name: 'dataization_business', component: Business },
    { path: '/qyh_product/:id', name: 'qyh_product', component: ProductShowView },
    { path: '/system', name: 'System', component: System }
  ]
})
router.beforeEach((to, from, next) => {
  // const paths = ['/login', '/']
  // if (paths.indexOf(to.path) === -1 && localStorage.routers.indexOf(to.path.substr(1)) === -1) {
  //   next('/')
  // }
  const isLogin = localStorage.token

  if (to.path === '/login') {
    isLogin ? next('/') : next()
  } else {
    localStorage.historyRoute = to.path
    console.log(localStorage.historyRoute)
    isLogin || to.path === '/wx_work' || to.path === '/wx_work_auth' || to.path === '/pdd_auth_callback' || to.path === '/work_weixin_auth_show' ? next() : next('/login')
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js